import React from "react"; // Uklonjen nepotreban import PropTypes
import styled, { keyframes, ThemeProvider } from "styled-components"; // ThemeProvider iz styled-components se ne koristi direktno ovde, ali styled komponente ga koriste implicitno
// import ScrollAnimation from 'react-animate-on-scroll'; // Komentarisano radi performansi

// Import slika
// Partners
import campi from "../images/sponsors/partners/campi.webp";
import premija from "../images/sponsors/partners/premija.webp";
import prima from "../images/sponsors/partners/prima.webp";
// import sabah from "../images/sponsors/partners/sabah.webp";
import fami from "../images/sponsors/partners/fami.webp";
import hanex from "../images/sponsors/partners/hanex.webp";
import magnat from "../images/sponsors/partners/magnat.webp";
import hayat from "../images/sponsors/partners/hayat.webp";
import teamTrade from "../images/sponsors/partners/teamTrade.webp";
import enkoPromet from "../images/sponsors/partners/enkoPromet.webp";
import hbc from "../images/sponsors/partners/hbc.webp";
import nit from "../images/sponsors/partners/nit.webp";
import stv from "../images/sponsors/partners/stv.webp";
import taksim from "../images/sponsors/partners/taksim.webp";
import tranzit from "../images/sponsors/partners/tranzit.webp";
import petStepeni from "../images/sponsors/partners/petStepeni.webp";

// Sponzori
import bitconex from "../images/sponsors/bitconex_logo.webp";
import np from "../images/sponsors/np.webp";
import doha from "../images/sponsors/doha.webp";
import kvele from "../images/sponsors/kvele.webp";
import tade from "../images/sponsors/tade.webp";
/* ===================== Keyframes i Styled Components ===================== */

const slides = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

const SponsorsSection = styled.section`
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  /* Styled komponente automatski dobijaju temu iz ThemeProvider-a u App.jsx */
  background: linear-gradient(
    180deg,
    ${(props) => props.theme.colors.background} 0%,
    ${(props) => props.theme.colors.surface} 100%
  );
  transition: background 0.3s ease;
`;

const SponsorsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.2rem;
  margin-bottom: 1rem;
  text-align: center;
  color: ${(props) => props.theme.colors.text};
  transition: color 0.3s ease;

  span {
    color: ${(props) => props.theme.colors.primary};
    position: relative;
    transition: color 0.3s ease;
    &:after {
      content: "";
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 6px;
      background: linear-gradient(
        90deg,
        ${(props) => props.theme.colors.primary},
        ${(props) => props.theme.colors.accent}
      );
      z-index: -1;
      opacity: 0.3;
      transition: background 0.3s ease;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: 1.8rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.textSecondary};
  text-align: center;
  max-width: 700px;
  margin: 0 auto 2rem;
  transition: color 0.3s ease;
`;

// Gold Sponsors
const GoldSponsorsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 4rem;
  // padding: 0 1.5rem; // Dupli padding ako SponsorsContainer već ima
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;
  }
`;

const GoldSponsorCard = styled.div`
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  background: ${(props) => props.theme.colors.surface};
  box-shadow: 0 6px 20px ${(props) => `${props.theme.colors.primary}20`};
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  min-width: 300px;
  max-width: 450px;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px ${(props) => `${props.theme.colors.primary}30`};
    &:before {
      transform: translateX(100%);
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${(props) => `${props.theme.colors.primary}1A`},
      transparent
    );
    transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

const GoldSponsorLogoContainer = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.background};
  border-bottom: 1px solid ${(props) => `${props.theme.colors.primary}20`};
  transition: background-color 0.3s ease;
`;

const GoldSponsorLogo = styled.img`
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.5s ease;
  loading: lazy; // Dodato lenjo učitavanje
  ${GoldSponsorCard}:hover & {
    transform: scale(1.05);
  }
`;

const GoldBadge = styled.div`
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  background: linear-gradient(135deg, #f59e0b, #fbbf24);
  color: #422006;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const GoldSponsorInfo = styled.div`
  padding: 1.4rem;
  width: 100%;
  background: ${(props) => props.theme.colors.surface};
  position: relative;
  text-align: center;
  transition: background 0.3s ease;
  border-radius: 0 0 16px 16px;
`;

const GoldSponsorName = styled.h4`
  font-size: 1.3rem;
  margin-bottom: 0.4rem;
  color: ${(props) => props.theme.colors.text};
  position: relative;
  display: inline-block;
  transition: color 0.3s ease;
  &:after {
    content: "";
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 3px;
    background: ${(props) => props.theme.colors.primary};
    border-radius: 2px;
    transition: all 0.4s ease;
  }
  ${GoldSponsorCard}:hover &:after {
    width: 80%;
    transform: translateX(-50%);
  }
`;

// Carousel
const LogosContainer = styled.div`
  overflow: hidden;
  padding: 30px 0;
  white-space: nowrap;
  position: relative;
  background: ${(props) => `${props.theme.colors.surface}CC`};
  border-radius: 12px;
  margin: 4rem 0;
  transition: background 0.3s ease;
  box-shadow: inset 0 0 15px ${(props) => `${props.theme.colors.primary}15`};
  &:before,
  &:after {
    /* Fading efekat */
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50px;
    z-index: 2;
    pointer-events: none;
  }
  &:before {
    left: 0;
    background: linear-gradient(
      to right,
      ${(props) => props.theme.colors.surface} 0%,
      transparent 100%
    );
  }
  &:after {
    right: 0;
    background: linear-gradient(
      to left,
      ${(props) => props.theme.colors.surface} 0%,
      transparent 100%
    );
  }
`;

const LogoItems = styled.div`
  display: inline-block;
  animation: ${slides} 60s linear infinite;
`;

const CarouselLogoWrapper = styled.div`
  width: 150px;
  height: 100px;
  border-radius: 10px;
  overflow: hidden;
  margin: 0 1.5rem;
  display: inline-flex; // Ostavite inline-flex za centriranje slike unutar kartice
  align-items: center; // Vertikalno centrira sliku UNUTAR kartice
  justify-content: center; // Horizontalno centrira sliku UNUTAR kartice
  vertical-align: middle; // <<--- DODAJTE OVU LINIJU (poravnava kartice međusobno)
  background: ${(props) => props.theme.colors.background};
  box-shadow: 0 4px 10px ${(props) => `${props.theme.colors.primary}1A`};
  transition: all 0.3s ease;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-5px) scale(1.03);
    box-shadow: 0 6px 15px ${(props) => `${props.theme.colors.primary}26`};
    border-color: ${(props) => `${props.theme.colors.primary}50`};
  }
`;

const CarouselLogoImg = styled.img`
  max-width: 85%;
  max-height: 85%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
  loading: lazy; // Dodato lenjo učitavanje
`;

// Silver Sponsors
const SponsorTier = styled.div`
  margin-top: 6rem;
  margin-bottom: 3rem;
  position: relative;
  &:last-child {
    margin-bottom: 0;
  }
`;

const TierTitle = styled.h3`
  text-align: center;
  margin-bottom: 3rem;
  font-size: 1.8rem;
  color: ${(props) => props.theme.colors.text};
  position: relative;
  font-weight: 700;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
  &:after {
    /* Linija */
    content: "";
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background: linear-gradient(
      90deg,
      ${(props) => props.theme.colors.primary},
      ${(props) => props.theme.colors.accent}
    );
    border-radius: 5px;
    transition: background 0.3s ease;
  }
  &:before {
    /* Zvezdica */
    content: "★";
    font-size: 1.1rem;
    color: ${(props) => props.theme.colors.primary};
    position: absolute;
    bottom: -28px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.6;
    transition: color 0.3s ease, opacity 0.3s ease;
  }
`;

const SilverSponsorsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); // ili 1fr
  }
`;

const SilverSponsorCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  background: ${(props) => props.theme.colors.surface};
  box-shadow: 0 6px 15px ${(props) => `${props.theme.colors.primary}1A`};
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 10px 25px ${(props) => `${props.theme.colors.primary}26`};
    &:before {
      transform: translateX(100%);
    }
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${(props) => `${props.theme.colors.primary}15`},
      transparent
    );
    transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

const SponsorImageContainer = styled.div`
  width: 100%;
  height: 160px;
  position: relative;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.background};
  border-bottom: 1px solid ${(props) => `${props.theme.colors.primary}20`};
  transition: background-color 0.3s ease;
`;

const SilverSponsorLogo = styled.img`
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.5s ease;
  loading: lazy; // Dodato lenjo učitavanje
  ${SilverSponsorCard}:hover & {
    transform: scale(1.05);
  }
`;

const SponsorBadge = styled.div`
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  background: linear-gradient(135deg, #94a3b8, #cbd5e1);
  color: #1e293b;
  font-size: 0.6rem;
  font-weight: bold;
  padding: 0.3rem 0.6rem;
  border-radius: 20px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
const BronzeSponsorBadge = styled.div`
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  background: linear-gradient(135deg, rgb(128, 74, 0), rgb(107, 59, 0));
  color: rgb(175, 175, 175);
  font-size: 0.6rem;
  font-weight: bold;
  padding: 0.3rem 0.6rem;
  border-radius: 20px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const SponsorInfo = styled.div`
  padding: 1.2rem;
  width: 100%;
  background: ${(props) => props.theme.colors.surface};
  position: relative;
  text-align: center;
  transition: background 0.3s ease;
  border-radius: 0 0 16px 16px;
`;

const SponsorName = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 0.4rem;
  color: ${(props) => props.theme.colors.text};
  position: relative;
  display: inline-block;
  transition: color 0.3s ease;
  &:after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 3px;
    background: ${(props) => props.theme.colors.primary};
    opacity: 0.7;
    border-radius: 2px;
    transition: all 0.4s ease;
  }
  ${SilverSponsorCard}:hover &:after {
    width: 70%;
    transform: translateX(-50%);
  }
`;

/* ===================== React Component ===================== */
function Sponsors() {
  // Nema potrebe za lokalnim stanjem teme ili prop-om,
  // jer ThemeProvider iz App.jsx radi posao.

  // Liste sponzora
  const sponsorLogos = [
    { name: "Campi", logo: campi },
    { name: "Premija", logo: premija },
    { name: "Prima", logo: prima },
    { name: "Fami", logo: fami },
    { name: "Hanex", logo: hanex },
    { name: "Magnat", logo: magnat },
    { name: "Hayat", logo: hayat },
    { name: "Team Trade", logo: teamTrade },
    { name: "Enko Promet", logo: enkoPromet },
    { name: "HBC", logo: hbc },
    { name: "Centar NIT", logo: nit },
    { name: "Sandžak TV", logo: stv },
    { name: "Taksim", logo: taksim },
    { name: "Tranzit", logo: tranzit },
    // { name: "Sabah", logo: sabah },
    { name: "Campi", logo: campi },
    { name: "Premija", logo: premija },
    { name: "Prima", logo: prima },
    { name: "Fami", logo: fami },
    { name: "Hanex", logo: hanex },
    { name: "Magnat", logo: magnat },
    { name: "Hayat", logo: hayat },
    { name: "Team Trade", logo: teamTrade },
    { name: "Enko Promet", logo: enkoPromet },
    { name: "HBC", logo: hbc },
    { name: "Centar NIT", logo: nit },
    { name: "Sandžak TV", logo: stv },
    { name: "Taksim", logo: taksim },
    { name: "Tranzit", logo: tranzit },
    { name: "Pet Stepeni", logo: petStepeni },
    // { name: "Sabah", logo: sabah },
    { name: "Campi", logo: campi },
    { name: "Premija", logo: premija },
    { name: "Prima", logo: prima },
    { name: "Fami", logo: fami },
    { name: "Hanex", logo: hanex },
    { name: "Magnat", logo: magnat },
    { name: "Hayat", logo: hayat },
    { name: "Team Trade", logo: teamTrade },
    { name: "Enko Promet", logo: enkoPromet },
    { name: "HBC", logo: hbc },
    { name: "Centar NIT", logo: nit },
    { name: "Sandžak TV", logo: stv },
    { name: "Taksim", logo: taksim },
    { name: "Tranzit", logo: tranzit },
    { name: "Pet Stepeni", logo: petStepeni },
    // { name: "Sabah", logo: sabah },
    { name: "Campi", logo: campi },
    { name: "Premija", logo: premija },
    { name: "Prima", logo: prima },
    { name: "Fami", logo: fami },
    { name: "Hanex", logo: hanex },
    { name: "Magnat", logo: magnat },
    { name: "Hayat", logo: hayat },
    { name: "Team Trade", logo: teamTrade },
    { name: "Enko Promet", logo: enkoPromet },
    { name: "HBC", logo: hbc },
    { name: "Centar NIT", logo: nit },
    { name: "Sandžak TV", logo: stv },
    { name: "Taksim", logo: taksim },
    { name: "Tranzit", logo: tranzit },
    { name: "Pet Stepeni", logo: petStepeni },
    // { name: "Sabah", logo: sabah },
  ];
  const goldSponsors = [
    { name: "Bitconex", logo: bitconex },
    // { name: "Digital Solutions", logo: "https://via.placeholder.com/150" },
  ];
  const silverSponsors = [
    { name: "Grad Novi Pazar", logo: np },
    /*   { name: "Silver Sponsor 2", logo: np },
    { name: "Silver Sponsor 3", logo: np }, */
  ];
  const BronzeSponsors = [
    { name: "Doha Invest", logo: doha },
    { name: "Kvele Petrol", logo: kvele },
    { name: "TadeCNC cut", logo: tade },
  ];

  return (
    // Nema potrebe za ThemeProvider-om ovde
    <SponsorsSection id="sponzori">
      <SponsorsContainer>
        <SectionTitle style={{ marginBottom: "3.5rem" }}>
          Naši <span>Gold</span> Sponzori
        </SectionTitle>

        <GoldSponsorsContainer>
          {goldSponsors.map((sponsor, index) => (
            // <ScrollAnimation animateIn="fadeInUp" duration={0.8} delay={index * 100} key={index} initiallyVisible={false} animateOnce={true}>
            <GoldSponsorCard key={index}>
              <GoldSponsorLogoContainer>
                <GoldSponsorLogo src={sponsor.logo} alt={sponsor.name} />
                <GoldBadge>Gold</GoldBadge>
              </GoldSponsorLogoContainer>
              <GoldSponsorInfo>
                <GoldSponsorName>{sponsor.name}</GoldSponsorName>
              </GoldSponsorInfo>
            </GoldSponsorCard>
            // </ScrollAnimation>
          ))}
        </GoldSponsorsContainer>

        {silverSponsors.length > 0 && (
          <SponsorTier>
            {/* <ScrollAnimation animateIn="fadeIn" duration={1.2} initiallyVisible={false} animateOnce={true}> */}
            <TierTitle>Silver Sponzori</TierTitle>
            <SilverSponsorsGrid>
              {silverSponsors.map((sponsor, index) => (
                // <ScrollAnimation animateIn="fadeInUp" duration={0.8} delay={index * 100} key={index} initiallyVisible={false} animateOnce={true}>
                <SilverSponsorCard key={index}>
                  <SponsorImageContainer>
                    <SilverSponsorLogo src={sponsor.logo} alt={sponsor.name} />
                    <SponsorBadge>Silver</SponsorBadge>
                  </SponsorImageContainer>
                  <SponsorInfo>
                    <SponsorName>{sponsor.name}</SponsorName>
                  </SponsorInfo>
                </SilverSponsorCard>
                // </ScrollAnimation>
              ))}
            </SilverSponsorsGrid>
            {/* </ScrollAnimation> */}
          </SponsorTier>
        )}
        {BronzeSponsors.length > 0 && (
          <SponsorTier>
            {/* <ScrollAnimation animateIn="fadeIn" duration={1.2} initiallyVisible={false} animateOnce={true}> */}
            <TierTitle>Bronzani Sponzori</TierTitle>
            <SilverSponsorsGrid>
              {BronzeSponsors.map((sponsor, index) => (
                // <ScrollAnimation animateIn="fadeInUp" duration={0.8} delay={index * 100} key={index} initiallyVisible={false} animateOnce={true}>
                <SilverSponsorCard key={index}>
                  <SponsorImageContainer>
                    <SilverSponsorLogo src={sponsor.logo} alt={sponsor.name} />
                    <BronzeSponsorBadge>Bronze</BronzeSponsorBadge>
                  </SponsorImageContainer>
                  <SponsorInfo>
                    <SponsorName>{sponsor.name}</SponsorName>
                  </SponsorInfo>
                </SilverSponsorCard>
                // </ScrollAnimation>
              ))}
            </SilverSponsorsGrid>
            {/* </ScrollAnimation> */}
          </SponsorTier>
        )}

        {/* <ScrollAnimation animateIn="fadeIn" duration={1} initiallyVisible={false} animateOnce={true}> */}
        <SectionTitle style={{ marginTop: "4rem" }}>
          Ostali <span>Partneri i Prijatelji</span>
        </SectionTitle>
        <SectionSubtitle>
          Zahvaljujemo na podršci partnerima i prijateljima ovog projekta.
        </SectionSubtitle>
        {/* </ScrollAnimation> */}

        <LogosContainer>
          <LogoItems>
            {sponsorLogos.concat(sponsorLogos).map((sponsor, index) => (
              <CarouselLogoWrapper key={`${sponsor.name}-${index}`}>
                <CarouselLogoImg src={sponsor.logo} alt={sponsor.name} />
              </CarouselLogoWrapper>
            ))}
          </LogoItems>
        </LogosContainer>
      </SponsorsContainer>
    </SponsorsSection>
  );
}

export default Sponsors;
